import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthCallback } from './pages/AuthCallback';
import { CALLBACK_PATH } from './lib/auth';
import './brand/fonts.css';
import './styles/globals.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

// Match the backdrop to the selected theme before first paint. Dark (navy) is the
// brand default; a stored 'light' preference flips to the cream register.
const storedTheme = window.localStorage.getItem('hennipenny-theme-preference');
document.documentElement.dataset.theme = storedTheme === 'light' ? 'light' : 'dark';
document.body.style.background = 'var(--theme-bg-outer)';

// The seitiate.app login redirects back to /auth/callback (a real path, served the
// SPA by nginx's index fallback). Handle it before the hash router boots.
const isAuthCallback = window.location.pathname.startsWith(CALLBACK_PATH);

createRoot(root).render(
  <StrictMode>{isAuthCallback ? <AuthCallback /> : <App />}</StrictMode>,
);
